import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getAccessToken } from "@/lib/cookies";

const BASE_URL = "https://api-v2.podus.org/api";
const AUTH_PREFIX = "G@V3l2023-new-podus-v001233-SyS";

export const baseApi = createApi({
  reducerPath: "api",
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: (headers) => {
      const token = getAccessToken();
      headers.set(
        "Authorization",
        `Bearer ${AUTH_PREFIX}:${token ?? ""}`,
      );
      return headers;
    },
  }),
  tagTypes: ["Auth"],
  endpoints: () => ({}),
});
